import Routes from './routes';
import { Provider } from 'react-redux';
import store from './store';
import {
  AuthProvider,
  NotificationProvider,
  useNetworkCheck,
} from './contexts';
import { ConfigProvider, Spin } from 'antd';

function App() {
  const { isOnline } = useNetworkCheck();

  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: 'Inter',
            fontSize: 12,
            colorTextQuaternary: 'hsl(0, 0%, 40%)',
          },
          components: {
            Tabs: {
              itemSelectedColor: '#4649ec',
              inkBarColor: '#4649ec',
              horizontalItemPadding: '8px 20px',
              itemHoverColor: '#4649ec',
            },
          },
        }}
      >
        <AuthProvider>
          <NotificationProvider>
            <Spin
              spinning={!isOnline}
              size="large"
              fullscreen
              tip={
                <div className="text-white/70 text-sm tracking-wide font-medium mt-2">
                  You are offline.
                  <br /> Looking for internet connection...
                </div>
              }
            ></Spin>
            <Routes></Routes>
          </NotificationProvider>
        </AuthProvider>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
